/* Cart Drawer - Countdown Timer (V_NWTN_CART_32 concluded — Var A 5-minute timer shipped to 100%) */
(function () {
  var STORAGE_KEY = 'c-cart-countdown-deadline';
  var tickHandle = null;
  var initialized = false;

  function getBanner() {
    return document.querySelector('.c-cart-countdown-banner');
  }

  function getInitialSeconds() {
    var banner = getBanner();
    if (!banner) return 0;
    return parseInt(banner.dataset.seconds, 10) || 0;
  }

  function getLoopSeconds() {
    var banner = getBanner();
    if (!banner) return 0;
    return parseInt(banner.dataset.loopSeconds, 10) || 0;
  }

  function getEmptyHost() {
    var form = document.getElementById('CartDrawerForm');
    if (!form) return null;
    return form.parentNode && form.parentNode.classList ? form.parentNode : form;
  }

  function getCartItemCount() {
    var banner = getBanner();
    var liquidCount = banner ? parseInt(banner.dataset.cartItemCount, 10) : 0;
    if (isNaN(liquidCount)) liquidCount = 0;
    var host = getEmptyHost();
    var notEmpty = host && !host.classList.contains('is-empty');
    return liquidCount > 0 ? liquidCount : (notEmpty ? 1 : 0);
  }

  function formatTime(totalSeconds) {
    if (totalSeconds < 0) totalSeconds = 0;
    var m = Math.floor(totalSeconds / 60);
    var s = totalSeconds % 60;
    var mm = m < 10 ? '0' + m : '' + m;
    var ss = s < 10 ? '0' + s : '' + s;
    return mm + ':' + ss;
  }

  function renderTime(seconds) {
    var banner = getBanner();
    if (!banner) return;
    var timeEl = banner.querySelector('.c-cart-countdown-banner__time');
    if (timeEl) timeEl.textContent = formatTime(seconds);
  }

  function readDeadline() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var n = parseInt(raw, 10);
      return isNaN(n) ? null : n;
    } catch (e) {
      return null;
    }
  } 

  function writeDeadline(timestamp) {
    try { localStorage.setItem(STORAGE_KEY, String(timestamp)); } catch (e) {}
  }

  function clearDeadline() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function tick() {
    var deadline = readDeadline();
    if (deadline === null) {
      stopInterval();
      return;
    }

    var remainingSec = Math.ceil((deadline - Date.now()) / 1000);

    if (remainingSec <= 0) {
      var loopSec = getLoopSeconds();
      if (loopSec <= 0) {
        clearDeadline();
        stopInterval();
        return;
      }
      writeDeadline(Date.now() + loopSec * 1000);
      renderTime(loopSec);
    } else {
      renderTime(remainingSec);
    }
  }

  function startInterval() {
    if (tickHandle !== null) return;
    tick();
    tickHandle = window.setInterval(tick, 1000);
  }

  function stopInterval() {
    if (tickHandle !== null) {
      window.clearInterval(tickHandle);
      tickHandle = null;
    }
  }

  function startFresh() {
    var initial = getInitialSeconds();
    if (initial <= 0) return;
    writeDeadline(Date.now() + initial * 1000);
    startInterval();
  }

  function resumeIfActive() {
    if (readDeadline() === null) return;
    startInterval();
  }

  function stopAndClear() {
    stopInterval();
    clearDeadline();
  }

  function syncCartCountFromEvent(detail) {
    var banner = getBanner();
    if (!banner) return;
    if (detail && detail.cart && typeof detail.cart.item_count !== 'undefined') {
      banner.dataset.cartItemCount = String(detail.cart.item_count);
    }
  }

  var prevItemCount = 0;

  function init() {
    if (initialized) return;
    if (!getBanner()) return;
    initialized = true;

    var form = document.getElementById('CartDrawerForm');

    prevItemCount = getCartItemCount();

    if (prevItemCount > 0) resumeIfActive();

    function handleCartCountChange(newCount) {
      if (newCount <= 0) {
        stopAndClear();
      } else if (prevItemCount <= 0) {
        stopAndClear();
        startFresh();
      } else if (readDeadline() === null) {
        startFresh();
      }
      prevItemCount = newCount;
    }

    document.addEventListener('cart:updated', function (evt) {
      syncCartCountFromEvent(evt.detail);
      handleCartCountChange(getCartItemCount());
    });

    var emptyHost = getEmptyHost();
    if (emptyHost) {
      var emptyObserver = new MutationObserver(function () {
        handleCartCountChange(getCartItemCount());
      });
      emptyObserver.observe(emptyHost, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('ajaxProduct:added', function () {
      var run = function () { handleCartCountChange(getCartItemCount()); };
      run();
      window.setTimeout(run, 250);
      window.setTimeout(run, 750);
    });

    document.addEventListener('drawerOpen', function () {
      if (!document.body.classList.contains('cart-drawer-open')) return;
      if (getCartItemCount() <= 0) return;
      if (readDeadline() !== null) return;
      startFresh();
    });

    if (form) {
      form.addEventListener('submit', function () {
        clearDeadline();
        stopInterval();
        startFresh();
      });
    }

    window.addEventListener('storage', function (evt) {
      if (evt.key !== STORAGE_KEY) return;
      tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* V_NWTN_PDP_41 | Apple Pay - PDP */
(function () {
  // Apple Pay express checkout button should only appear for shoppers whose
  // device/browser can actually use Apple Pay. ApplePaySession exists in Safari
  // only; canMakePayments() reports device capability. When not eligible we add
  // no flag, so the CSS keeps the button (and any fallback wallet) hidden.
  function applePayEligible() {
    try {
      return !!(
        window.ApplePaySession &&
        typeof window.ApplePaySession.canMakePayments === 'function' &&
        window.ApplePaySession.canMakePayments()
      );
    } catch (e) {
      return false;
    }
  }

  function flagApplePay() {
    if (!document.body) return;
    document.body.classList.toggle('c-V_NWTN_PDP_41-applePayOk', applePayEligible());
  }

  if (document.body) {
    flagApplePay();
  } else {
    document.addEventListener('DOMContentLoaded', flagApplePay);
  }
})();

/* V_NWTN_PDP_39 | PDP - Bongs - Complete Set
   Concluded — control won. The 3-product "Complete the Set" bundle module
   (c-bundle-offer-triple / data-c-triple-atc) and its snippet are removed; the
   Control 2-product bundle logic in custom.js is the only bundle logic left. */

/* V_NWTN_CART_45 | Estimated Delivery Timeline - Cart Drawer
   Concluded — Var A won and is rolled out to all shoppers, so there is no
   variant gate left. Below each cart-drawer line item, show a dynamic
   "Ships by <day>, if ordered today." message. The copy template and the
   weekday names are rendered by Liquid (theme settings) onto each element's
   data attributes — JS only computes which weekday applies to the shopper's
   current day and fills the placeholder. Ship-by day = the next day, but we
   never promise a Sunday delivery (Sat -> Mon, Sun -> Mon). CSS keeps the
   element hidden outside the drawer, and until it's filled. */
(function () {
  function shipDayIndex() {
    var today = new Date().getDay(); // 0 = Sunday ... 6 = Saturday
    var idx = (today + 1) % 7;       // next calendar day
    if (idx === 0) idx = 1;          // no Sunday shipping -> Monday
    return idx;
  }

  function fillNode(node, idx) {
    if (node.getAttribute('data-c-eta-ready') === '1') return; // already done (avoids observer loops)
    var template = node.getAttribute('data-c-eta-template') || '';
    var days = (node.getAttribute('data-c-eta-days') || '').split(',');
    var dayName = (days[idx] || '').trim();
    if (!template || !dayName) return;
    var textEl = node.querySelector('.c-cart-eta__text') || node;
    textEl.textContent = template.replace('[day]', dayName);
    node.setAttribute('data-c-eta-ready', '1');
  }

  function apply() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;
    var nodes = drawer.querySelectorAll('.c-cart-eta');
    if (!nodes.length) return false;
    var idx = shipDayIndex();
    nodes.forEach(function (node) { fillNode(node, idx); });
    return true;
  }

  // The drawer's line items are (re)rendered async via cart.ajax.liquid, so re-run
  // whenever the cart changes. Fresh nodes have no data-c-eta-ready attr, so they
  // get filled; already-filled nodes are skipped.
  function observeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer._cEtaObserved) return;
    drawer._cEtaObserved = true;
    new MutationObserver(function () { apply(); }).observe(drawer, { childList: true, subtree: true });
  }

  function bootstrap() {
    observeDrawer();
    if (apply()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      observeDrawer();
      if (apply() || tries > 30) window.clearInterval(timer);
    }, 150);
  }

  if (document.readyState !== 'loading') {
    bootstrap();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrap);
  }
  // Cart re-renders fire these events, matching the other cart-drawer modules.
  ['cart:updated', 'ajaxProduct:added', 'drawerOpen'].forEach(function (evt) {
    document.addEventListener(evt, function () { apply(); });
  });
})();

/* V_NWTN_MIX_51 | Free Shipping Thresholds - Sitewide
   Concluded — Var A ($75) shipped to 100%. The cart drawer's own free-shipping bar is
   visible for everyone again and reads its threshold straight from the
   "Minimum $ amount for free Shipping" theme setting, which theme.js buildCart() keeps
   in sync via data-limit. No test JS is needed here anymore. */

/* V_NWTN_PDP_42 | Highball Hand Pipe PDP — Complete Your Session Module
   Concluded — control won. The module did not exist in Control, so its JS,
   CSS and snippets are removed outright and nothing remains here. */

/* V_NWTN_PDP_49 | Press Recognition - PDP
   Concluded — Var A won and is rolled out to all shoppers. Var A is pure markup
   + CSS and never needed JS, and the Var B gallery infographic was removed along
   with its template and settings, so nothing remains here. */

/* V_NWTN_SITE_52 | Free Shipping Threshold - V2
   Concluded — Var A ($77) won and shipped to 100%. The threshold now lives in the
   "Minimum $ amount for free Shipping" theme setting, which theme.js buildCart() keeps
   in sync via data-limit, and the threshold copy was written into the real copy
   settings on each surface. No test JS, snippet or copy-swap CSS is needed anymore. */
